import svDateLocale from 'date-fns/locale/sv';
import { LocaleEnum } from '@/__generated__/graphql';
import { messages as commonEN } from './en/index';
import { messages as commonSV } from './sv/index';

export const locales = {
  en: LocaleEnum.En,
  sv: LocaleEnum.Sv,
};

export const messages = {
  en: commonEN,
  sv: commonSV,
};

export const langs = {
  [locales.sv]: 'sv-SE',
  [locales.en]: 'en-GB',
};

export const dateLocales = {
  sv: svDateLocale,
};
